import { getJobById, getJobTitles } from "../../services/JobService";
import {
    JOBBYID_CONFIRMED_ACTION,
    JOBBYID_FAILED_ACTION,
    JOBTITLE_CONFIRMED_ACTION,
    JOBTITLE_FAILED_ACTION
} from "./actionTypes";
export function jobTitleListAction() {
    return (dispatch) => {
        getJobTitles()
            .then((response) => {
                dispatch(confirmedJobTitleAction(response));
            })
            .catch((error) => {
                const errorMessage = error.response ? error.response.data : 'Network Error';
                dispatch(jobTitleFailedAction(errorMessage));
            });
    };
}

export function jobByIdAction(id) {
    return (dispatch) => {
        getJobById(id)
            .then((response) => {
                dispatch(confirmedJobByIdAction(response));
            })
            .catch((error) => {
                const errorMessage = error.response ? error.response.data : 'Network Error';
                dispatch(jobTitleFailedAction(errorMessage));
            });
    };
}

export function confirmedJobByIdAction(payload) {
    return {
        type: JOBBYID_CONFIRMED_ACTION,
        payload,
    };
}

export function jobByIdFailedAction(data) {
    return {
        type: JOBBYID_FAILED_ACTION,
        payload: data,
    };
}


export function confirmedJobTitleAction(payload) {
    return {
        type: JOBTITLE_CONFIRMED_ACTION,
        payload,
    };
}

export function jobTitleFailedAction(data) {
    return {
        type: JOBTITLE_FAILED_ACTION,
        payload: data,
    };
}


